import { alpha, makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  identity: { display: "flex", alignItems: "flex-start", gap: 14, minWidth: 210, maxWidth: 420 },
  icon: {
    width: 44, height: 44, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center",
    borderRadius: 12, color: theme.palette.primary.main, backgroundColor: alpha(theme.palette.primary.main, 0.08),
    "& svg": { fontSize: 23 },
  },
  identityText: { minWidth: 0 },
  title: {
    display: "block", fontSize: 14, fontWeight: 600, lineHeight: 1.9, color: theme.palette.text.primary,
    textDecoration: "none", overflowWrap: "anywhere", "&:hover": { color: theme.palette.primary.main },
    "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 3, borderRadius: 3 },
  },
  subtitle: {
    fontSize: 12, lineHeight: 1.9, color: theme.palette.text.secondary, marginTop: 5,
    overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflowWrap: "anywhere",
  },
  badges: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 6, marginBottom: 7 },
  type: {
    display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, fontWeight: 600,
    color: theme.palette.primary.main, "& svg": { fontSize: 15 },
  },
  statusList: { display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 7 },
  inactive: { color: theme.palette.text.secondary, backgroundColor: alpha(theme.palette.text.primary, 0.055), "& svg": { color: "inherit" } },
  archived: { color: theme.palette.warning.dark, backgroundColor: alpha(theme.palette.warning.main, 0.1), "& svg": { color: "inherit" } },
  details: { display: "grid", gap: 7, minWidth: 130 },
  detail: { display: "flex", alignItems: "center", gap: 7, color: theme.palette.text.secondary, fontSize: 12, lineHeight: 1.8, "& svg": { fontSize: 16, flexShrink: 0 } },
  date: { fontSize: 12, color: theme.palette.text.secondary, whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" },
  actions: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 7, width: "100%" },
  moreAction: { marginInlineStart: "auto", flexShrink: 0 },
  mobileHeader: { alignItems: "flex-start", flexWrap: "nowrap", "& $identity": { minWidth: 0 }, "& $statusList": { flexShrink: 0 } },
  mobileBody: { display: "flex", flexWrap: "wrap", alignItems: "flex-start", justifyContent: "space-between", gap: 16, padding: "0 16px 16px" },
  mobileFooter: { justifyContent: "space-between" },
}));
